var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('h2',{domProps:{"innerHTML":_vm._s(_vm.task.question)}})])]),_vm._v(" "),_c('div',{staticClass:"mx-auto",staticStyle:{"background-color":"lightgray","height":"300px","width":"700px"},attrs:{"id":"mdiv"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }